<template>
  <div class="cursor-pointer">
    <etrusted-widget
      class="relative"
      :class="{ 'z-[-1]': id === 'plp' }"
      :data-etrusted-widget-id="$domain.etrustedId[id]"
      :data-sku="sku"
    />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  id: 'plp' | 'pdp' | 'basket';
  sku?: string;
}
defineProps<Props>();

const { $domain } = useNuxtApp();
</script>
